import { SVGProps, Ref, forwardRef } from 'react';

export const EyeCrossedFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 20a9.8 9.8 0 0 1-2.212-.26l-.815 3.258-1.746-.436.84-3.363a15.8 15.8 0 0 1-3.27-1.801L2.44 20.54 1 19.46l2.38-3.174C1.497 14.658.228 12.913 0 12c.5-2 6-8 12-8s11.5 6 12 8c-.228.913-1.497 2.658-3.38 4.286L23 19.46l-1.44 1.08-2.357-3.142a15.7 15.7 0 0 1-3.27 1.8l.84 3.364-1.746.436-.815-3.258A9.8 9.8 0 0 1 12 20"
                fill="currentColor"
            />
        </g>
    </svg>
));
EyeCrossedFilledSize24Glyph.displayName = 'EyeCrossedFilledSize24Glyph';
